<template>
    <!-- "Add Notes" of Create Universal Quote (Android UniversalQuoteNotesFragment, quote id -1): the notes are only kept
         here and go out with manual-quote/create as `notes` (JSON [{ notes, sender_name, created_at }]) -->
    <div class="uqc w-full flex flex-col gap-[12px] px-[6px] font-roboto">
        <h4 class="m-0 text-[16px] font-medium text-[#F67280]">
            Universal Quote Notes
        </h4>
        <ul class="list-none m-0 p-0 flex flex-col gap-[10px]">
            <li v-for="(note, index) in list" :key="index">
                <div class="rounded-[10px] p-[10px] bg-[#EFEFEF] text-[13px] text-[#333333] break-words">
                    <div class="flex items-start justify-between gap-2">
                        <p class="m-0 mb-[2px] font-medium">{{ note.sender_name }}</p>
                        <button type="button" aria-label="Remove note"
                            class="p-0 border-0 bg-transparent text-[#EE5851] leading-none" @click="list.splice(index, 1)">
                            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                                <path d="M6 6l12 12M18 6 6 18" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" />
                            </svg>
                        </button>
                    </div>
                    <p class="m-0 whitespace-pre-line">{{ note.notes }}</p>
                </div>
                <p class="m-0 mt-[4px] px-[2px] text-[11px] text-[#999999]">{{ formatDate(note.created_at) }}</p>
            </li>
            <li v-if="!list.length" class="py-4 text-center text-[13px] text-[#999999]">No notes added yet</li>
        </ul>
        <!-- Enter = add, Shift+Enter = new line, grows to 120px (chat/SmsConversation.vue) -->
        <div class="flex items-end gap-2 rounded-[10px] bg-white shadow-[0px_0px_20px_0px_#00000026] p-[5px] pl-[10px]">
            <textarea ref="input" v-model="text" rows="1" maxlength="1000" placeholder="Enter Message Here"
                class="flex-1 min-w-0 max-h-[120px] py-[6px] border-0 outline-none resize-none bg-transparent text-[14px] text-[#333333]"
                @input="grow" @keydown.enter.exact.prevent="add" />
            <button type="button" :disabled="!text.trim()" aria-label="Add note"
                class="w-[30px] h-[30px] flex-shrink-0 rounded-[6px] bg-[#EFEFEF] border-0 flex items-center justify-center disabled:opacity-50"
                @click="add">
                <i class="fa fa-paper-plane text-[#7695FF]" />
            </button>
        </div>
    </div>
    <div class="uqcFooter mt-auto flex items-center justify-end gap-[10px] px-[6px]">
        <button type="button" class="uqcBtnNext" @click="$emit('done', list)">
            Done
        </button>
    </div>
</template>

<script>
import moment from "moment";

export default {
    props: {
        // notes added so far: [{ notes, sender_name, created_at (unix seconds) }]
        notes: { type: Array, default: () => [] },
    },
    emits: ["done"],
    data() {
        return {
            list: [...this.notes],
            text: "",
            senderName: JSON.parse(localStorage.getItem("user") || "{}")?.user?.full_name || "",
        };
    },
    mounted() {
        this.$refs.input.focus();
    },
    methods: {
        add() {
            const notes = this.text.trim();
            if (!notes) return;
            this.list.push({ notes, sender_name: this.senderName, created_at: String(moment().unix()) });
            this.text = "";
            this.$nextTick(this.grow);
        },
        grow() {
            const el = this.$refs.input;
            el.style.height = "auto";
            el.style.height = Math.min(el.scrollHeight, 120) + "px";
        },
        formatDate(ts) {
            return moment.unix(Number(ts)).format("MM/DD/YYYY hh:mm A");
        },
    },
};
</script>
